var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"app_button",class:[
    `app_button_${_vm.type}`,
    `app_button_size_${_vm.size}`
  ],attrs:{"type":"button","disabled":_vm.disabled},on:{"click":_vm.handleClick}},[_vm._t("default",function(){return [_vm._v("Button")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }